module.exports = __webpack_public_path__ + "static/media/Illustration.9991b072.png";